import { ElementRef, forwardRef } from "react";

import { font } from "./font";

interface FontDecoratorsProps {
  children: React.ReactNode;
}

const FontDecorators = forwardRef<ElementRef<"div">, FontDecoratorsProps>(
  (props, ref) => {
    const { children } = props;
    return (
      <div className={font.variable} ref={ref}>
        {children}
      </div>
    );
  },
);
FontDecorators.displayName = "FontDecorators";

export { FontDecorators };
